import styles from "./ProxyVoteIcon.module.css";
import ProxyVoteIconSVG from "./Proxy_Vote_Icon.svg";

/**
 * View Component. Displays an icon to show that the user has a proxied vote and they've been voted for
 */

export function ProxyVoteIcon() {
  return <img src={ProxyVoteIconSVG} className={styles.img} alt="Proxy Vote" />;
}
